import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const HP_SPONSORED_LISTINGS_TEST = 'HP_SponsoredListingsModule';
export const HP_AD_NEW_TOP_PLACEMENT_TEST = 'HP_Ad_NewTopPlacement';

export const trackHpAdNewTopPlacementTest = (): void => {
    trackAbTestV2Variant(HP_AD_NEW_TOP_PLACEMENT_TEST);
};

export const isHpSponsoredListingsModuleVariant = (): boolean =>
    getAbTestV2(HP_SPONSORED_LISTINGS_TEST)?.variant === 'variant';

export const trackHpSponsoredListingsModuleTest = (): void => {
    trackAbTestV2Variant(HP_SPONSORED_LISTINGS_TEST);
};
